import pxToRem from "assets/theme/functions/pxToRem";
import { noteTypography } from "shared/styles/style";
import { descriptionTypography } from "shared/styles/style";
import { titleTypography } from "shared/styles/style";

export function cardStyles(theme) {
  const {
    breakpoints,
    palette,
    functions: { pxToRem },
  } = theme;

  return {
    cursor: "pointer",
    width: "100%",
    height: pxToRem(120),
    borderRadius: pxToRem(15),
    background: palette.white.main,
    boxShadow: "0px 5px 14px 0px rgba(0, 0, 0, 0.05)",
    padding: `${pxToRem(16)} ${pxToRem(24)}`,

    "@media(max-width:1920px)": {
      padding: `${pxToRem(14)} ${pxToRem(20)}`,
      height: pxToRem(120),
    },

    "@media(max-width:1600px)": {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      height: pxToRem(100),
    },
    "@media(max-width:1550px)": {
      padding: `${pxToRem(12)} ${pxToRem(22)}`,
      height: pxToRem(100),
    },
    "@media(max-width:1440px)": {
      padding: `${pxToRem(9)} ${pxToRem(22)}`,
      height: pxToRem(100),
    },
    "@media(max-width:1280px)": {
      padding: `${pxToRem(12)} ${pxToRem(18)}`,
      height: pxToRem(80),
    },
  };
}

export const textContainerStyle = (theme) => {
  const { breakpoints } = theme;
  return {
    flexGrow: 1,
    maxWidth: "calc(100% - 48px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "8px",

    "@media(max-width:1920px)": {
      maxWidth: "calc(100% - 40px)",
    },

    "@media(max-width:1600px)": {
      maxWidth: "calc(100% - 36px)",
    },

    "@media(max-width:1280px)": {
      maxWidth: "calc(100% - 35px)",
    },

    "@media(max-width:375px)": {
      maxWidth: "calc(100% - 30px)",
    },
  };
};

export const titleStyle = ({
  palette,
  typography,
  breakpoints,
  functions: { pxToRem },
}) => ({
  ...descriptionTypography(breakpoints),
  lineHeight: 1.25,
  letterSpacing: pxToRem(0.52),
  whiteSpace: "wrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "uppercase",
  fontWeight: 700,
  "@media(max-width:1440px)": {
    fontSize: pxToRem(12),
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  "@media(max-width:1366px)": {
    fontSize: pxToRem(11),
  },
});

export const progressStyle = ({ palette, typography, breakpoints }) => ({
  ...titleTypography(breakpoints),
  // color: "#FFFFFF",
});

export const logoContainerStyle = (
  { breakpoints, functions: { pxToRem } },
  { logoBg }
) => ({
  width: pxToRem(48),
  height: pxToRem(48),
  borderRadius: pxToRem(9999),
  background: logoBg,
  flexBasis: pxToRem(48),
  flexGrow: 0,

  "@media(max-width:1920px)": {
    width: pxToRem(40),
    height: pxToRem(40),
    flexBasis: pxToRem(40),
  },

  "@media(max-width:1600px)": {
    width: pxToRem(36),
    height: pxToRem(36),
    flexBasis: pxToRem(36),
  },
  "@media(max-width:1280px)": {
    width: pxToRem(30),
    height: pxToRem(30),
    flexBasis: pxToRem(30),
  },
});

export const logoStyle = ({ breakpoints, functions: { pxToRem } }) => ({
  width: pxToRem(23),
  height: pxToRem(23),

  "@media(max-width:1920px)": {
    width: pxToRem(20),
    height: pxToRem(20),
  },

  "@media(max-width:1600px)": {
    width: pxToRem(16),
    height: pxToRem(16),
  },

  "@media(max-width:577px)": {
    width: pxToRem(12),
    height: pxToRem(12),
  },
  "@media(max-width:1280px)": {
    width: pxToRem(8),
    height: pxToRem(8),
  },
});

export const diffStyle = ({ typography, breakpoints }, { diff }) => ({
  ...noteTypography(breakpoints),
  color: diff > 0 ? "#2dce89" : "#e01e5a",

  "@media(max-width:1920px)": {
    fontSize: pxToRem(14),
  },

  "@media(max-width:1600px)": {
    fontSize: pxToRem(12),
  },
  // "@media(max-width:1366px)": {
  //   fontSize: pxToRem(9),
  // },
  // "@media(max-width:1280px)": {
  //   fontSize: pxToRem(8),
  // },
});

export const timeStyle = ({ palette, typography, breakpoints }) => ({
  ...noteTypography(breakpoints),

  "@media(max-width:1920px)": {
    fontSize: pxToRem(14),
  },

  "@media(max-width:1600px)": {
    fontSize: pxToRem(10),
  },

  "@media(max-width:1366px)": {
    fontSize: pxToRem(9),
  },

  "@media(max-width:1280px)": {
    fontSize: pxToRem(8),
  },
});
